//#region src/index.ts
const SemanticColors = {
	light: {
		surface: "#f8f9fc",
		surfaceDim: "#d9dadd",
		surfaceBright: "#f8f9fc",
		surfaceContainerLowest: "#ffffff",
		surfaceContainerLow: "#f2f3f6",
		surfaceContainer: "#edeef1",
		surfaceContainerHigh: "#e7e8eb",
		surfaceContainerHighest: "#e1e2e5",
		onSurface: "#191c1e",
		onSurfaceVariant: "#484456",
		inverseSurface: "#2e3133",
		inverseOnSurface: "#f0f1f4",
		outline: "#797488",
		outlineVariant: "#cac3d9",
		surfaceTint: "#642cf7",
		primary: "#5300e7",
		onPrimary: "#ffffff",
		primaryContainer: "#6c38ff",
		onPrimaryContainer: "#e9e0ff",
		inversePrimary: "#cbbeff",
		secondary: "#8a5100",
		onSecondary: "#ffffff",
		secondaryContainer: "#fe9800",
		onSecondaryContainer: "#643900",
		tertiary: "#005a3c",
		onTertiary: "#ffffff",
		tertiaryContainer: "#007550",
		onTertiaryContainer: "#71fec0",
		error: "#ba1a1a",
		onError: "#ffffff",
		errorContainer: "#ffdad6",
		onErrorContainer: "#93000a",
		primaryFixed: "#e7deff",
		primaryFixedDim: "#cbbeff",
		onPrimaryFixed: "#1e0060",
		onPrimaryFixedVariant: "#4c00d3",
		secondaryFixed: "#ffdcbd",
		secondaryFixedDim: "#ffb86f",
		onSecondaryFixed: "#2c1600",
		onSecondaryFixedVariant: "#693c00",
		tertiaryFixed: "#6ffbbe",
		tertiaryFixedDim: "#4edea3",
		onTertiaryFixed: "#002113",
		onTertiaryFixedVariant: "#005236",
		background: "#f8f9fc",
		onBackground: "#191c1e",
		surfaceVariant: "#e1e2e5"
	},
	dark: {
		surface: "#121316",
		surfaceDim: "#121316",
		surfaceBright: "#39393f",
		surfaceContainerLowest: "#0d0e11",
		surfaceContainerLow: "#1c1d22",
		surfaceContainer: "#23242a",
		surfaceContainerHigh: "#2d2e35",
		surfaceContainerHighest: "#383940",
		onSurface: "#e2e2e6",
		onSurfaceVariant: "#c9c5d2",
		inverseSurface: "#e2e2e6",
		inverseOnSurface: "#2e3035",
		outline: "#928f99",
		outlineVariant: "#48454e",
		surfaceTint: "#cbbeff",
		primary: "#cbbeff",
		onPrimary: "#1e0060",
		primaryContainer: "#4c00d3",
		onPrimaryContainer: "#e7deff",
		inversePrimary: "#5300e7",
		secondary: "#ffb86f",
		onSecondary: "#4a2800",
		secondaryContainer: "#693c00",
		onSecondaryContainer: "#ffdcbd",
		tertiary: "#4edea3",
		onTertiary: "#003824",
		tertiaryContainer: "#005236",
		onTertiaryContainer: "#6ffbbe",
		error: "#ffb4ab",
		onError: "#690005",
		errorContainer: "#93000a",
		onErrorContainer: "#ffdad6",
		primaryFixed: "#e7deff",
		primaryFixedDim: "#cbbeff",
		onPrimaryFixed: "#1e0060",
		onPrimaryFixedVariant: "#4c00d3",
		secondaryFixed: "#ffdcbd",
		secondaryFixedDim: "#ffb86f",
		onSecondaryFixed: "#2c1600",
		onSecondaryFixedVariant: "#693c00",
		tertiaryFixed: "#6ffbbe",
		tertiaryFixedDim: "#4edea3",
		onTertiaryFixed: "#002113",
		onTertiaryFixedVariant: "#005236",
		background: "#121316",
		onBackground: "#e2e2e6",
		surfaceVariant: "#48454e"
	}
};
const BrandColors = {
	google: {
		blue: "#4285f4",
		green: "#34a853",
		yellow: "#fbbc05",
		red: "#ea4335",
		surface: "#ffffff",
		onSurface: "#1f1f1f",
		outline: "#747775",
		hover: "#f8faff",
		focus: "#0b57d0"
	},
	apple: {
		surface: "#000000",
		onSurface: "#ffffff",
		hover: "#2c2c2c"
	},
	link: "#3c87f7"
};
const Spacing = {
	half: 2,
	one: 4,
	two: 8,
	gutter: 12,
	three: 16,
	containerPadding: 20,
	four: 24,
	five: 32,
	six: 64
};
const Radii = {
	sm: 8,
	default: 16,
	md: 24,
	lg: 32,
	xl: 48,
	full: 9999
};
const Typography = {
	display: {
		fontSize: 36,
		lineHeight: 44,
		fontWeight: "800",
		letterSpacing: -.72
	},
	headlineLg: {
		fontSize: 28,
		lineHeight: 36,
		fontWeight: "700",
		letterSpacing: -.28
	},
	headlineLgMobile: {
		fontSize: 24,
		lineHeight: 32,
		fontWeight: "700"
	},
	headlineMd: {
		fontSize: 20,
		lineHeight: 28,
		fontWeight: "700"
	},
	bodyLg: {
		fontSize: 18,
		lineHeight: 26,
		fontWeight: "500"
	},
	bodyMd: {
		fontSize: 16,
		lineHeight: 24,
		fontWeight: "400"
	},
	labelMd: {
		fontSize: 14,
		lineHeight: 20,
		fontWeight: "600",
		letterSpacing: .14
	},
	labelSm: {
		fontSize: 12,
		lineHeight: 16,
		fontWeight: "600",
		letterSpacing: .24
	}
};
const Layout = { maxContentWidth: 800 };
//#endregion
export { BrandColors, Layout, Radii, SemanticColors, Spacing, Typography };

//# sourceMappingURL=index.js.map